import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const searchPresentaciones = async (query, limit = 100, offset = 0) => {
  const response = await axios.post(`${API_URL}/api/search-presentaciones`, {
    query,
    limit,
    offset,
  });

  return response.data;
};

export const createPresentacion = async (items) => {
  const response = await axios.post(`${API_URL}/api/presentaciones/create`, {
    items,
  });

  return response.data;
};

/** Crear presentaciones con FLUX 2 Pro (Replicate) o GPT Image 2 / Nano Banana.
 * Opcional: prompt (extraPrompt), folder, plantilla, marca, templateConfig, engine.
 */
export const createPresentacionReplicate = async (
  items,
  extraPrompt,
  folder,
  plantilla,
  marca,
  templateConfig,
  engine,
) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-replicate`,
    {
      items,
      ...(extraPrompt ? { extraPrompt } : {}),
      ...(folder ? { folder } : {}),
      ...(plantilla ? { plantilla } : {}),
      ...(marca ? { marca } : {}),
      ...(templateConfig ? { templateConfig } : {}),
      ...(engine ? { engine } : {}),
    }
  );

  return response.data;
};

/** Crear presentación con modelo/avatar + prenda (FLUX 2 Pro). Opcional: prompt, folder, plantilla, marca, templateConfig, modelPathBack. */
export const createPresentacionAvatar = async (
  modelPath,
  items,
  extraPrompt,
  folder,
  plantilla,
  marca,
  templateConfig,
  modelPathBack,
) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-avatar`,
    {
      modelPath,
      items,
      ...(extraPrompt ? { extraPrompt } : {}),
      ...(folder ? { folder } : {}),
      ...(plantilla ? { plantilla } : {}),
      ...(marca ? { marca } : {}),
      ...(templateConfig ? { templateConfig } : {}),
      ...(modelPathBack ? { modelPathBack } : {}),
    }
  );

  return response.data;
};

/** Listar carpetas de destino dentro de PRESENTACIONES_GENERADAS. */
export const getPresentacionFolders = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/folders`);
  return response.data;
};

/** Crear carpeta dentro de PRESENTACIONES_GENERADAS. */
export const createPresentacionFolder = async (folderName) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-folder`,
    { folder: folderName }
  );
  return response.data;
};

/** Listar carpetas dentro de AI_DESIGNS (FOTOS_WEB). */
export const getDesignFolders = async () => {
  const response = await axios.get(`${API_URL}/api/designs/folders`);
  return response.data;
};

/** Crear carpeta dentro de AI_DESIGNS (FOTOS_WEB). */
export const createDesignFolder = async (folderName) => {
  const response = await axios.post(`${API_URL}/api/designs/create-folder`, {
    folder: folderName,
  });
  return response.data;
};

/** Listar avatares (modelos) disponibles. */
export const getAvatares = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/avatars`);
  return response.data;
};

/** Subir nuevo avatar (modelo). FormData con campo "file". */
export const uploadAvatar = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await axios.post(
    `${API_URL}/api/presentaciones/upload-avatar`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

/** Listar plantillas (PDF o imagen convertida). */
export const getPlantillas = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/plantillas`);
  return response.data;
};

/** Subir plantilla (PDF o imagen). FormData con campo "file". */
export const uploadPlantilla = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await axios.post(
    `${API_URL}/api/presentaciones/upload-plantilla`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

/** Crear un nuevo diseño desde prompt + referencias (se guarda en FOTOS_WEB y se indexa automático). */
export const createNuevoDiseno = async ({ prompt, engine, name, folder, refs }) => {
  const form = new FormData();
  form.append("prompt", prompt || "");
  if (engine) form.append("engine", engine);
  if (name) form.append("name", name);
  if (folder) form.append("folder", folder);
  (refs || []).forEach((f) => form.append("refs", f));

  const response = await axios.post(`${API_URL}/api/designs/create`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
